// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { Scrollbars } from "react-custom-scrollbars-2";
// import { useHistory } from "react-router-dom";

// const Sidebar = () => {
//   const [selectedItems, setSelectedItems] = useState(Array().fill(false));
//   const [path, setPath] = useState("");
//   const navigate = useHistory();

//   const handleItemClick = (index, key) => {
//     console.log(index, key, "indexx");
//     if (path == index && key == index) {
//       setPath(false);
//     } else if (key == index) {
//       setPath(index);
//     }

//     setSelectedItems((prevSelectedItems) => {
//       const updatedSelectedItems = [...prevSelectedItems];
//       console.log("selectedItems", selectedItems);
//       // Close the previously opened item
//       updatedSelectedItems.forEach((item, i) => {
//         if (i !== index) {
//           updatedSelectedItems[i] = false;
//         }
//       });

//       // Toggle the state of the clicked item
//       updatedSelectedItems[index] = !updatedSelectedItems[index];

//       return updatedSelectedItems;
//     });
//   };

//   const handleLogout = () => {
//     localStorage.clear();
//     navigate.push("/login");
//   };

//   useEffect(() => {
//     function handleMouseOver(e) {
//       e.stopPropagation();
//       if (
//         document.body.classList.contains("mini-sidebar") &&
//         document.querySelector("#toggle_btn").offsetParent !== null
//       ) {
//         var targ = e.target.closest(".sidebar");
//         if (targ) {
//           document.body.classList.add("expand-menu");
//           document
//             .querySelectorAll(".subdrop + ul")
//             .forEach((ul) => (ul.style.display = "block"));
//         } else {
//           document.body.classList.remove("expand-menu");
//           document
//             .querySelectorAll(".subdrop + ul")
//             .forEach((ul) => (ul.style.display = "none"));
//         }
//         return false;
//       }
//     }

//     document.addEventListener("mouseover", handleMouseOver);

//     return () => {
//       document.removeEventListener("mouseover", handleMouseOver);
//     };
//   }, []);

//   return (
//     <>
//       <div className="sidebar" id="sidebar">
//         <Scrollbars>
//           <div className="sidebar-inner slimscroll">
//             <div id="sidebar-menu" className="sidebar-menu">
//               <ul className="sidebar-vertical">
//                 <li className="submenu">
//                   <Link
//                     id="1"
//                     to="/dashboard"
//                     key={1}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleItemClick(1, e?.target?.id);
//                     }}
//                     className={`${path == "1" ? "subdrop" : ""} ${
//                       path == "1" ? "active" : ""
//                     }`}
//                   >
//                     <i className="fe fe-home" /> <span> Dashboard</span>
//                   </Link>
//                 </li>
//                 <li className="submenu">
//                   <Link
//                     id="1"
//                     to="/master"
//                     key={1}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleItemClick(1, e?.target?.id);
//                     }}
//                     className={`${path == "1" ? "subdrop" : ""} ${
//                       path == "1" ? "active" : ""
//                     }`}
//                   >
//                     <i className="fa-solid fa-brain"></i>
//                     <span> Master</span>
//                   </Link>
//                 </li>

//                 <li className="submenu">
//                   <Link
//                     id="1"
//                     to="/user"
//                     key={1}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleItemClick(1, e?.target?.id);
//                     }}
//                     className={`${path == "1" ? "subdrop" : ""} ${
//                       path == "1" ? "active" : ""
//                     }`}
//                   >
//                     <i
//                       className="fa fa-child"
//                       data-bs-toggle="tooltip"
//                       title="fa fa-child"
//                     />
//                     <span>User</span>
//                   </Link>
//                 </li>
//                 <li className="submenu">
//                   <Link
//                     id="1"
//                     to="/profile"
//                     key={1}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleItemClick(1, e?.target?.id);
//                     }}
//                     className={`${path == "1" ? "subdrop" : ""} ${
//                       path == "1" ? "active" : ""
//                     }`}
//                   >
//                     <i
//                       className="fa fa-user-secret"
//                       data-bs-toggle="tooltip"
//                       title="fa fa-user-secret"
//                     />
//                     <span>Profile</span>
//                   </Link>
//                 </li>
//                 <li className="submenu">
//                   <Link
//                     id="1"
//                     to="#"
//                     key={1}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleLogout(); 
//                     }}
//                     className={`${path == "1" ? "subdrop" : ""} ${
//                       path == "1" ? "active" : ""
//                     }`}
//                   >
//                     <i className="fa fa-unlink" />
//                     <span>Logout</span>
//                   </Link>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </Scrollbars>
//       </div>
//     </>
//   );
// };
// export default Sidebar;

import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";
import { useHistory } from "react-router-dom";

const Sidebar = () => {
  const [path, setPath] = useState("");
  const navigate = useHistory();
  const location = useLocation();

  useEffect(() => {
    setPath(location.pathname);
  }, [location]);

  const handleItemClick = (index) => {
    setPath(index);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate.push("/login");
  };

  return (
    <>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul className="sidebar-vertical">
                {[
                  { path: "/dashboard", label: "Dashboard", icon: "fe fe-home" },
                  { path: "/master", label: "Master", icon: "fa-solid fa-brain" },
                  { path: "/user", label: "User", icon: "fa fa-child" },
                  { path: "/profile", label: "Profile", icon: "fa fa-user-secret" },
                  { path: "/logout", label: "Logout", icon: "fa fa-unlink", logout: true },
                ].map((item, index) => (
                  <li key={index} className="submenu">
                    <Link
                      to={item.logout ? "#" : item.path}
                      onClick={(e) => {
                        e.stopPropagation();
                        item.logout ? handleLogout() : handleItemClick(item.path);
                      }}
                      className={`${path === item.path ? "subdrop active" : ""}`}
                     
                    >
                      <i className={item.icon} />
                      <span> {item.label}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

export default Sidebar;
